import { ItemType, NavigationItem } from '../../../../models/Navigation';

export const dealsDropdownOptions = (userPermissions: string[] | undefined): NavigationItem[] => {
  if (userPermissions && userPermissions.includes('ui:deals_pipeline:combined_view')) {
    return [
      {
        type: ItemType.NAVLINK,
        text: 'Bonds',
        to: '/deals-pipeline/bond',
      },
      {
        type: ItemType.NAVLINK,
        text: 'Loans',
        to: '/deals-pipeline/loans',
      },
      {
        type: ItemType.NAVLINK,
        text: 'Combined',
        to: '/deals-pipeline/combined',
      },
    ];
  }

  return [
    {
      type: ItemType.NAVLINK,
      text: 'Bonds',
      to: '/deals-pipeline/bond',
    },
    {
      type: ItemType.NAVLINK,
      text: 'Loans',
      to: '/deals-pipeline/loans',
    },
  ];
};
